import {Inject, Injectable} from '@angular/core';
import {
  COMMON_ICONS,
  CoreSettings,
  IconService,
  Language,
  LV_LOGO,
  SETTINGS,
  TranslationService
} from '@lv1871/core';
import * as de from '../../translations/de';

@Injectable()
export class AppInitializer {

  constructor(private _translationService: TranslationService, private _iconService: IconService,
              @Inject(SETTINGS) private _settings: CoreSettings) {
  }

  public init() {
    this._translationService.addTranslations(Language.DE, de.translations);
    this._translationService.useLanguage(this._settings.translationLanguage, Language.DE);
    this._iconService.registerIcons([LV_LOGO, ...COMMON_ICONS]);
  }
}
